<script>
    import { navigate }                from "svelte-routing"
    import { company, companyId, dpo } from '../shared/stores.js'
    import { companyChanged }          from '../shared/utils.js'
    import Modal                       from '../shared/Modal.svelte'
    import CompanyDropdown             from '../shared/CompanyDropdown.svelte'

    function changed(it) {
        $companyId = companyChanged(it) 
    }

    function newCompany() {
        navigate('/empresas')
    }

</script>

<style>
    .it {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: baseline;
    }

    .it > * {
        margin: 0 10px;
    }
</style>

{#if $company && $company.id}
    <div class="center-it" style="color: white">
        <h1>{$company.name}</h1>
        {#if $dpo}
            <h3>Modo DPO</h3>
        {/if}
    </div>
{:else}
    <Modal display={true}>
        <div slot="content" class="content">
            <div class="ui center aligned basic segment">
                <div class="it">
                    <p>Escolha uma</p>
                    <CompanyDropdown onChange={changed}/>
                </div>
                <div class="ui horizontal divider">Ou</div>
                <button class="ui big inverted violet button" on:click={newCompany}>
                    Cadastre uma empresa nova
                </button>
            </div>
        </div>
    </Modal>
{/if}
